export const DEFAULT_PAGINATION_LIMIT = 20

export const VISIT_TABS = {
  OFFERS: 'offers',
  VISITS: 'visits',
}

export const VISIT_TABS_LIST = [
  {
    tabText: 'Offers',
    id: VISIT_TABS.OFFERS,
  },
  {
    tabText: 'Visits',
    id: VISIT_TABS.VISITS,
  },
]
